import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { Grid, GridColumn as Column, GridSortChangeEvent } from '@progress/kendo-react-grid';
import DocumentTitleCell, { DocumentCreatedCell } from './DocumentTitleCell';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    documents: Document[];
    isLoading: boolean;
    childId: number;
    sort: SortDescriptor[];
}

type Document = {
    DocumentID: number;
    Title: string;
    Description: string;
    Type: string;
}

export default class Documents extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            documents: [],
            isLoading: true,
            childId: 0,
            sort: [],
        }

        this.sortChange = this.sortChange.bind(this);
        this.upload = this.upload.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestDocuments(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.documents && this.state.childId != childId) {
            this.requestDocuments(childId);
        }
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            documents: orderBy(this.state.documents, event.sort)
        });
    }

    public render() {
        return <React.Fragment>
            <br />
            <div className="row">
                <div className="col">
                    <h1>Documents</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" onClick={this.upload}>Upload</button>
                </div>
            </div>
            <Grid
                data={this.state.documents}
                sortable={{ allowUnsort: true }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <Column field="Title" cell={DocumentTitleCell} />
                <Column field="Description" />
                <Column field="CreatedDate" title="Created Date" cell={DocumentCreatedCell} />
            </Grid>
        </React.Fragment>;
    }

    private requestDocuments(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/Document/List/1/${childId}`)
            .then((documents: Document[]) => {
                this.setState({ isLoading: false, documents });
            });
    }

    private upload() {
        this.props.history.push(`/documents/upload`, { childId: this.state.childId });
    }
}
